module.exports = __webpack_public_path__ + "static/scale-model-of-oswald-rooming-house-museums-in-dallas-texas-2d30acb04a160d15f167cef3ceab5c0f.png";